module.exports = __webpack_public_path__ + "static/media/meal_and_food_support.19a5d208.svg";